module.exports = __webpack_public_path__ + "img/senalando-izqpr.png.e0546895.webp";